import { useRef } from 'react';

const useLatest = ({ value, }) => {
    const ref = useRef(value);
    ref.current = value;
    return {
        ref,
    };
};

export { useLatest as u };
//# sourceMappingURL=hook-BihLfH9C.js.map
